"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var SvgWarning = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 49 49" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.204 39.047a2.297 2.297 0 1 1 4.594 0 2.297 2.297 0 0 1-4.594 0zM24.5 15.313c.846 0 1.532.686 1.532 1.531v15.313a1.531 1.531 0 0 1-3.062 0V16.845c0-.846.685-1.532 1.53-1.532z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.2.536a5.218 5.218 0 0 1 6.984 2.383l19.34 39.397A4.638 4.638 0 0 1 44.36 49H4.64a4.636 4.636 0 0 1-4.163-6.682L19.817 2.92A5.212 5.212 0 0 1 22.2.536zm4.236 3.733a2.156 2.156 0 0 0-3.87 0l-19.34 39.4a1.575 1.575 0 0 0 1.414 2.268h39.721a1.576 1.576 0 0 0 1.416-2.267L26.436 4.27z" }))); };
exports["default"] = SvgWarning;
